<div>
    <app-page-header 
        [title]="pageTitle" 
        [description]="pageDescription"> 
    </app-page-header>
    
    <div mat-dialog-content (keyup.enter)="onSaveClick()">
        <app-vendor-template *ngIf="vendor"
            [vendor]="vendor"
            (isValidChanged)="isValidChanged($event)">
        </app-vendor-template>
    </div>
    
    <mat-divider></mat-divider>
    
    <div mat-dialog-actions class="d-flex justify-content-end">
        <button 
            class="btn btn-default"
            (click)="onCancelClick()">
            Cancel
        </button>
        <button
            *appUserRoleUp="[ Role.Admin ]"
            [disabled]="!isValid"
            class="btn btn-primary margin-left-md"
            [mat-dialog-close]="vendor">
            Apply changes 
        </button>
    </div>
</div>